import styled from 'styled-components';
const CardListMLStyled = styled.div`
  box-shadow: 0 0 5px 0 rgba(181, 181, 181, 0.26);
  border-radius: 12px;
  background-color: white;
  padding: 24px 8px;
  padding-bottom: 16px;
  .card-list {
    display: flex;
    flex-wrap: wrap;
    height: 224px;
    overflow-y: hidden;
    transition: all 300ms linear;
    &.collapse {
      height: ${(props) => props.cardHeight}px;
      transition: all 300ms linear;
    }
    > div {
      height: 200px;
      width: 33.33%;
      padding: 0 16px;
      margin-bottom: 24px;
      .card-content {
        border-radius: 4px;
        display: flex;
        color: #fff;
        .left-content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 32px 0;
          > .title {
            font-size: 20px;
            line-height: 20px;
          }
          > .desc {
            font-size: 16px;
            margin-top: 12px;
            height: 40px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          > .MuiButton-root {
            background-color: #fff;
            color: #1565c0;
            font-size: 16px;
            /* .MuiButtonBase-root {
              margin-right: 0;
              width: 108px;
            } */

            margin-top: 24px;
          }
        }
        .right-img {
          width: 200px;
          height: 200px;
          > img {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      }
    }
  }
  .toggle {
    /* margin-top: ${(props) => (props.collapse ? '' : '24px')}; */
    text-align: center;
    .icon {
      cursor: pointer;
      width: 28px;
      height: 14px;
    }
  }
`;
export default CardListMLStyled;
